import { render, staticRenderFns } from "./FileFilters.vue?vue&type=template&id=048f027f&scoped=true"
import script from "./FileFilters.vue?vue&type=script&lang=js"
export * from "./FileFilters.vue?vue&type=script&lang=js"
import style0 from "./FileFilters.vue?vue&type=style&index=0&id=048f027f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f027f",
  null
  
)

export default component.exports